export default function SceneRecommendation() {
  const scenes = [
    {
      icon: 'ri-store-2-line',
      title: 'コンビニでの利用',
      description: 'セブン-イレブン、ローソン、ファミリーマートなど',
      recommendedCards: [
        {
          name: '三井住友カード（NL）',
          rate: '最大7%',
          detail: 'スマホタッチ決済で対象コンビニ・飲食店で高還元',
          url: '/mitsui'
        },
        {
          name: 'dカード',
          rate: '1.0%～2.5%',
          detail: 'd払い連携でさらにお得',
          url: '/dcard'
        }
      ]
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'ネット通販での利用',
      description: 'Amazon、ECモール、Yahoo!ショッピングなど',
      recommendedCards: [
        {
          name: '国際ブランド系カード W',
          rate: '最大5.5%',
          detail: 'Amazonでポイント最大5.5倍',
          url: '/jcbw'
        },
        {
          name: '大手ECモール系カード',
          rate: '最大3%',
          detail: 'ECモールでポイント最大3倍',
          url: '/rakuten'
        }
      ]
    },
    {
      icon: 'ri-restaurant-line',
      title: '飲食店での利用',
      description: 'マクドナルド、スターバックス、ファミレスなど',
      recommendedCards: [
        {
          name: '三井住友カード（NL）',
          rate: '最大7%',
          detail: '対象飲食店でスマホタッチ決済利用時',
          url: '/mitsui'
        },
        {
          name: '国際ブランド系カード W',
          rate: '最大5.5%',
          detail: 'スターバックスで高還元',
          url: '/jcbw'
        }
      ]
    },
    {
      icon: 'ri-hotel-line',
      title: '旅行・宿泊での利用',
      description: 'ホテル予約、航空券、レンタカーなど',
      recommendedCards: [
        {
          name: 'リクルートカード',
          rate: '最大4.2%',
          detail: 'じゃらんで最大4.2%還元',
          url: '/recruit'
        },
        {
          name: '大手ECモール系カード',
          rate: '最大3%',
          detail: 'トラベルでポイント最大3倍',
          url: '/rakuten'
        }
      ]
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'スーパー・ドラッグストアでの利用',
      description: 'イオン、マツモトキヨシ、ウエルシアなど',
      recommendedCards: [
        {
          name: 'dカード',
          rate: '最大4.5%',
          detail: 'マツモトキヨシなどで高還元',
          url: '/dcard'
        },
        {
          name: 'リクルートカード',
          rate: '1.2%',
          detail: '基本還元率1.2%でどこでもお得',
          url: '/recruit'
        }
      ]
    },
    {
      icon: 'ri-smartphone-line',
      title: '携帯料金・公共料金の支払い',
      description: 'スマホ代、電気代、ガス代、水道代など',
      recommendedCards: [
        {
          name: 'リクルートカード',
          rate: '1.2%',
          detail: '固定費の支払いでも1.2%還元',
          url: '/recruit'
        },
        {
          name: 'dカード',
          rate: '1.0%',
          detail: 'ドコモユーザーなら特典多数',
          url: '/dcard'
        }
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          利用シーン別おすすめクレジットカード
        </h3>
        <p className="text-center text-gray-600 mb-12">
          よく使うお店やサービスに合わせて、最もお得なカードを選びましょう
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {scenes.map((scene, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-xl transition-all"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${scene.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-[#003366] mb-2">{scene.title}</h4>
                  <p className="text-sm text-gray-600">{scene.description}</p>
                </div>
              </div>

              <div className="space-y-4">
                {scene.recommendedCards.map((card, cardIndex) => (
                  <div
                    key={cardIndex}
                    className="bg-white rounded-lg p-4 border-2 border-gray-200 hover:border-[#FFB800] transition-all"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <h5 className="font-bold text-[#003366]">{card.name}</h5>
                      <span className="text-lg font-bold text-[#FFB800]">{card.rate}</span>
                    </div>
                    <p className="text-sm text-gray-700 mb-3">{card.detail}</p>
                    <a
                      href={card.url}
                      className="inline-block text-[#003366] text-sm font-bold hover:text-[#FFB800] transition-colors cursor-pointer"
                    >
                      詳細を見る →
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#FFB800] to-[#FFA000] rounded-xl p-8 text-center">
          <h4 className="text-2xl font-bold text-white mb-4">
            複数のカードを使い分けるのがおすすめ！
          </h4>
          <p className="text-white mb-6">
            利用シーンに応じて2〜3枚のカードを使い分けることで、ポイント還元率を最大化できます。<br />
            年会費無料のカードなら、複数持ちでも維持コストはゼロです。
          </p>
          <a
            href="#ranking"
            className="inline-block bg-white text-[#FFB800] px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            おすすめカードを見る
          </a>
        </div>
      </div>
    </section>
  );
}
